<template>
  <b-nav-item-dropdown
    id="dropdown-grouped"
    variant="link"
    class="dropdown-language"
    right
  >
    <template #button-content>
      <feather-icon
        icon="GlobeIcon"
        size="16"
      />
      <span
        class="sr-only"
        v-text="$t('locale.label')"
      />
      <span
        class="ml-50 text-body"
        v-text="currentLocale.name"
      />
    </template>
    <b-dropdown-item
      v-for="localeObj in locales"
      :key="localeObj.locale"
      :active="localeObj.locale === $i18n.locale"
      @click="setLocale(localeObj.locale)"
    >
      <span v-text="localeObj.name" />
    </b-dropdown-item>
  </b-nav-item-dropdown>
</template>

<script>
import { BNavItemDropdown, BDropdownItem } from 'bootstrap-vue'
import { setLocale } from '@/libs/i18n/locale'

// Dil adları kendi dilinde yazılır (endonim), çevrilmez.
const locales = [
  { locale: 'tr', name: 'Türkçe' },
  { locale: 'en', name: 'English' },
]

export default {
  components: {
    BNavItemDropdown,
    BDropdownItem,
  },
  computed: {
    currentLocale() {
      return locales.find(l => l.locale === this.$i18n.locale) || locales[0]
    },
  },
  setup() {
    return {
      locales,
      setLocale,
    }
  },
}
</script>
